import {TemplateAttributes} from 'config-migration/MigrationConstants';
import {ObjectWithAttributes} from 'config-migration/types/MigrationObjects';

import {MigrationStep} from '../../types/MigrationStep';
import {PlanningTab} from '../../types/MigrationStep';

/**
 * This method returns true if a template is plannable during the current step/tab.
 * We only want to plan Execution templates during the Workflows step / on the Workflow pane.
 * All other templates should only be planned during the Templates step / on the Templates pane.
 *
 * An Execution template has `processTaskSchemaId` in its object attributes while other templates should be
 * grouped by their `templateCollectionId`
 *
 * Works with both MigrationStep (legacy UI) and PlanningTab (tabs UI) since the string values
 * for PROCESS_TASK_SCHEMAS and TEMPLATES are the same in both enums.
 */
export function isTemplatePlannedOnStep(
  object: ObjectWithAttributes,
  stepOrTab: MigrationStep | PlanningTab
): boolean {
  if (stepOrTab !== 'PROCESS_TASK_SCHEMAS' && stepOrTab !== 'TEMPLATES') {
    return false;
  }

  const expectedGrouperAttribute = stepOrTab === 'TEMPLATES' ? 'templateCollectionId' : 'processTaskSchemaId';

  return (object.objectAttributes as TemplateAttributes)?.[expectedGrouperAttribute] != null;
}

// Alias for tabs UI - keeps existing imports working
export const isTemplatePlannedOnTab = isTemplatePlannedOnStep;
